











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Typography, TextField } from '@/components/atoms';

export type CampaignSettingsInputProps = {
  label?: string;
  value: string;
  type: 'number' | 'text';
  maxlength?: string;
  placeholder?: string;
};

@Component({
  components: { Typography, TextField }
})
export default class CampaignSettings extends Vue {
  @Prop({ default: '' }) readonly title!: string;
  @Prop({ default: '' }) readonly label!: string;
  @Prop({ default: '' }) readonly textFieldDescription?: string;
  @Prop({ default: false }) readonly showExtraInput?: boolean;
  @Prop() readonly extraInputProps?: CampaignSettingsInputProps;
}
